// src/pages/Asatizah.jsx
import { useMemo } from "react";
import {
    FiUser,
    FiCalendar,
    FiBookOpen,
    FiBell,
    FiExternalLink,
    FiCheckCircle,
} from "react-icons/fi";

import "../styles/Pengenalan.css";

export default function Asatizah() {
    const href = useMemo(() => "https://asatizah.etikaf.com", []);
    const open = () => window.open(href, "_blank", "noopener,noreferrer");

    return (
        <div className="pg-wrap">
            <div className="container pg-container">
                {/* HERO */}
                <div className="pg-hero">
                    <div>
                        <h1 className="pg-h1">Asatizah Etikaf</h1>

                        <p className="pg-lead">
                            <b>Asatizah</b> ialah platform untuk guru/ustaz/ustazah mengurus jadual kuliah,
                            poster & bahan, serta paparan aktiviti masjid yang berkaitan.
                            Ia memudahkan penyelarasan antara pihak masjid dan asatizah —
                            supaya maklumat sampai kepada jemaah dengan lebih kemas dan konsisten.
                        </p>

                        <div className="pg-hero-actions">
                            <button className="pg-btn pg-btn-primary" type="button" onClick={open}>
                                <FiExternalLink /> Teruskan ke Asatizah
                            </button>

                        </div>


                    </div>

                    {/* Right card */}
                    <div className="pg-side-card">
                        <div className="pg-side-head">
                            <div className="pg-side-ic">
                                <FiUser />
                            </div>
                            <div>
                                <div className="pg-side-title">Untuk asatizah / penceramah</div>
                                <div className="pg-side-sub">Jadual, bahan, dan kemaskini</div>
                            </div>
                        </div>

                        <div className="pg-side-body">
                            <div className="pg-side-mini">
                                <div className="pg-mini-row">
                                    <FiCheckCircle /> Urus jadual & poster
                                </div>
                                <div className="pg-mini-row">
                                    <FiCheckCircle /> Selaras dengan masjid
                                </div>
                                <div className="pg-mini-row">
                                    <FiCheckCircle /> Paparan lebih teratur
                                </div>
                            </div>

                            <div className="pg-note" style={{ marginTop: 12 }}>
                                Jemaah boleh lihat maklumat melalui paparan masjid / web
                            </div>
                        </div>
                    </div>
                </div>

                {/* Info */}
                <div className="pg-section" id="asatizah-info">
                    <div className="pg-section-title">
                        <span className="pg-kicker">Overview</span>
                        <h2 className="pg-h2">Apa yang Asatizah boleh bantu?</h2>
                        <p className="pg-desc">
                            Fokus kepada penyelarasan kuliah dan bahan dengan lebih mudah.
                        </p>
                    </div>

                    <div className="pg-grid-3">
                        <div className="pg-card">
                            <div className="pg-card-icon"><FiCalendar /></div>
                            <div>
                                <div className="pg-card-title">Kalendar Kuliah</div>
                                <div className="pg-card-text">
                                    Susun jadual mengikut tarikh/masa & lokasi dengan kemas.
                                </div>
                            </div>
                        </div>

                        <div className="pg-card">
                            <div className="pg-card-icon"><FiBookOpen /></div>
                            <div>
                                <div className="pg-card-title">Poster & Bahan</div>
                                <div className="pg-card-text">
                                    Sediakan poster ringkas untuk dikongsi dan dipaparkan.
                                </div>
                            </div>
                        </div>

                        <div className="pg-card">
                            <div className="pg-card-icon"><FiBell /></div>
                            <div>
                                <div className="pg-card-title">Kemaskini Pantas</div>
                                <div className="pg-card-text">
                                    Perubahan maklumat boleh dikemaskini tanpa kelam-kabut.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>




            </div>
        </div>
    );
}
